import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BreadCrumb = ({ brandText }: { brandText: string }) => {
  const { t } = useTranslation();

  return (
    <div className="ml-[6px]  ">
      <div className="h-6 w-[224px] pt-1">
        <a
          className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
          href=" "
        >
          {t("breadcrumb.pages")}
          <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
            {" "}
            /{" "}
          </span>
        </a>
        <Link
          className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
          to="#"
        >
          {brandText}
        </Link>
      </div>
      <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
        <Link
          to="#"
          className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
        >
          {brandText}
        </Link>
      </p>
    </div>
  );
};

export default BreadCrumb;
